import { render, staticRenderFns } from "./InitiativeFlowCard.vue?vue&type=template&id=ba9561d2&scoped=true"
import script from "./InitiativeFlowCard.vue?vue&type=script&lang=js"
export * from "./InitiativeFlowCard.vue?vue&type=script&lang=js"
import style0 from "./InitiativeFlowCard.vue?vue&type=style&index=0&id=ba9561d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9561d2",
  null
  
)

export default component.exports